import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import orgConfig from 'org/configs/org.config';

function InstoreMotto() {
  const { earnType, instoreLabel } = orgConfig;

  return (
    <div className="mn_instoreMotto">
      Earn {earnType} when you shop <span className="mn_noWrap">{instoreLabel}<span className="mn_dot">.</span></span>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><InstoreMotto {...props} /></ComponentErrorBoundary>;
